import React from "react";
import DataTable from "../../../components/DataTable";

export default function SkeyechartDatasourcesTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
}) {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "20%",
      sorter: (a, b) =>
        (a.id || "").toString().localeCompare((b.id || "").toString()),
    },
    {
      title: "Backend",
      dataIndex: "backend",
      key: "backend",
      width: "30%",
      sorter: (a, b) => (a.backend || "").localeCompare(b.backend || ""),
    },
    {
      title: "Database Name",
      dataIndex: "database_name",
      key: "database_name",
      width: "30%",
      sorter: (a, b) =>
        (a.database_name || "").localeCompare(b.database_name || ""),
    },
    {
      title: "Last Changed",
      dataIndex: "changed_on_delta_humanized",
      key: "changed_on_delta_humanized",
      width: "20%",
      sorter: (a, b) =>
        (a.changed_on_delta_humanized || "").localeCompare(
          b.changed_on_delta_humanized || "",
        ),
    },
  ];

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
